import React, { useCallback } from "react";
import { useRouter } from "next/router";

import SearchIcon from "../../Icons/Search";
import TextInput from "../../TextInput";
import fastpanel from "../../../utils/fastpanel";

const DesktopSearchInput = () => {
  const router = useRouter();
  const { query } = router;
  const { q = "" } = query;

  const seachSubmit = useCallback(
    (event: any) => {
      event.preventDefault();

      const query = event.target?.[0]?.value || "";

      fastpanel({
        name: "pbr_search_requested",
        data: {
          entry_point: "all",
          searched_for: query,
        },
      });

      const href = query ? `/search?q=${query}` : `/cards`;
      router.push(href);
    },
    [router]
  );

  return (
    <form className="w-60" onSubmit={seachSubmit} data-cnstrc-autosuggest>
      <div className="relative flex items-center">
        <TextInput
          className="paragraph-small py-0 h-10"
          data-cnstrc-search-input
          placeholder="Search"
          type="text"
          defaultValue={q}
          autoCapitalize="none"
        />
        <button
          className="absolute right-0 mr-3 items-center"
          data-cnstrc-search-submit-btn
          aria-hidden="true"
          type="submit"
        >
          <SearchIcon width="1.5rem" height="1.5rem" />
        </button>
      </div>
    </form>
  );
};

export default React.memo(DesktopSearchInput);
